import { render, staticRenderFns } from "./ChildsDeadChart.vue?vue&type=template&id=e01b6570&scoped=true"
import script from "./ChildsDeadChart.vue?vue&type=script&lang=js"
export * from "./ChildsDeadChart.vue?vue&type=script&lang=js"
import style0 from "./ChildsDeadChart.vue?vue&type=style&index=0&id=e01b6570&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01b6570",
  null
  
)

export default component.exports